/**
 * Enumeration of possible `CONTEXT` types (events and actions) that 
 * we could manage with the notifications in core
 * 
 * Each time we create a new element here, we should add a new component in helpers
 * 
 * Use this enum to set the CONTEXT property of a Notification object
 * and determine how the notification should be displayed.
 * 
 * The convention will be:
 *  - events have participle verb keys: UPDATED, REMOVED, ADDED, SENT, etc
 *  - actions have infinitive verbs: START, STOP, maybe CLOSE, OPEN, etc...
 * 
 * @enum { string } 
 */
export enum NotificationsContextEnum {
  // TODO GENERIC EVENT FAILED NOTIFICATION
  EVENT_FAILED = 'event.failed',
  /** EVENT_VERSION_STATUS_UPDATED - Artwork Status Change */
  EVENT_VERSION_STATUS_UPDATED_SUCCESS = 'event.versions.status.updated.success',
  EVENT_VERSION_STATUS_UPDATED_FAILED = 'event.versions.status.updated.failed',
  /** EVENT_VERSION_APPROVAL_SENT - Artwork Approved/Rejected */
  EVENT_VERSION_APPROVAL_SENT_SUCCESS = 'event.versions.approvals.updated.success',
  EVENT_VERSION_APPROVAL_SENT_FAILED = 'event.versions.approvals.updated.failed',
  // Annotations
  EVENT_FILE_ANNOTATIONS_UPDATED_FAILED = 'event.files.annotations.updated.failed',
  
  /** ACTION_RECORD - Screen recording action */
  ACTION_RECORD_START = 'action.record.start',
  ACTION_RECORD_STOP = 'action.record.stop',
  ACTION_RECORD_PAUSE = 'action.record.pause',
  ACTION_RECORD_RESUME = 'action.record.resume', // for continue after pause

  // ACTIONS FOR FILE
  EVENT_FILES_COMPRESSION_START = 'action.files.compression.start',
  EVENT_FILE_ANNOTATIONS_START = 'action.files.annotations.start', // single file wiht annotations
}